import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { ReactNode } from 'react';

import { Card } from '../Card/Card';

export const CardsListSkeleton = ({
  action,
  cardCount = 3,
  cardRows = 1,
  rowHeight,
  title,
}: {
  action?: ReactNode;
  cardCount?: number;
  cardRows?: number;
  rowHeight?: number | string;
  title?: ReactNode;
}) => {
  return (
    <>
      {Array.from({ length: cardCount }).map((_, index) => (
        <Box
          key={index}
          sx={{
            mb: 2,
          }}
        >
          <Card action={action} key={index} title={title ?? <Skeleton variant="text" width="200px" />}>
            {Array.from({ length: cardRows }).map((_, index) => (
              <Box
                key={index}
                sx={{
                  mb: 2,
                }}
              >
                <Skeleton height={rowHeight} variant="rectangular" />
              </Box>
            ))}
          </Card>
        </Box>
      ))}
    </>
  );
};
